import EDHttp from '../utils/EDHttp';

export default
  {
    getAdmins: async function (domainId, page = 0)
    {
      try
      {
        const result = await EDHttp.get(`/employer/list/${domainId}?page=${page}`);
        return result.data.data;
      } catch (error)
      {
        throw error.response.data.message;
      }
    },
    createEmployerAdmin: async function (body)
    {
      try
      {
        const result = await EDHttp.post(`/employer/user`, body);
        return result.data.data;
      } catch (error)
      {
        throw error.response.data.message;
      }
    },
    updateAdmin: async function (adminId, data)
    {
      try
      {
        const result = await EDHttp.put(`/employer/user/${adminId}`, data);
        return result.data.data;
      } catch (error)
      {
        throw error.response.data.message;
      }
    },
    deleteAdmin: async function (employerId, domainId)
    {
      try
      {
        const result = await EDHttp.delete(`/employer/${employerId}/${domainId}`);
        return result.data.data;
      } catch (error)
      {
        throw error.response.data.message;
      }
    },
      employerAdminReset: async function (id, password = "") {
            try {
                const result = await EDHttp.post(`/admin/reset/auth/employer/${id}`,{password});
                return result.data.data;
            } catch (error) {
                throw error.response.data.message;
            }
        },
  }